<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {},
  mounted() {
    var ua = navigator.userAgent.toLowerCase()
    var isWeixin = ua.indexOf('micromessenger') != -1
    if (isWeixin) {
      return true
    } else {
      if (this.$mConfig.isWxBrowser) {
        this.$router.push({ path: '/wxOpen' })
      }

      return false
    }
  },

  methods: {
    // async loadCity(){
    // 	try{
    // 		 console.log('进来了loadCity同步接口')
    // 		await this.$axios.get('site/list').then(res => {
    // 			if (res.data.code == 200) {
    // 				this.$store.commit('SET_ALLSITE',JSON.stringify(res.data.data));
    // 			}else{
    // 				let data={'浙江': ['杭州']};
    // 				this.$store.commit('SET_ALLSITE',JSON.stringify(res.data.data));
    // 			}
    // 		})
    // 	}catch(e){
    // 		if (this.$mConfig.debug) {
    // 			console.log(e);
    // 		};
    // 	};
    // },
  },
  created() {
    // if(localStorage.citys){
    // 	this.loadCity();
    // };
  },
}
</script>

<style>
.setHeightFullGrey {
  padding: 0;
  overflow: hidden;
  min-height: 100vh;
  background: #f8f8f8;
}
.setHeightFullWhite {
  padding: 0;
  overflow: hidden;
  min-height: 100vh;
  background: #fff;
}
.setWhite {
  background: #fff !important;
}
.setGrey {
  background: #f8f8f8 !important;
}
.setOrangeColor {
  color: #fab13e !important;
}
.marginLeftXm {
  margin-left: 5px;
}
.blank90 {
  width: 90%;
  margin: 0 auto;
}
.blank95 {
  width: 95%;
  margin: 0 auto;
}
.paddingbottom50 {
  padding-bottom: 50px;
}
.paddingTopBottomXm {
  padding: 5px 0;
}
.paddingTopBottomXs {
  padding: 10px 0;
}
.flexRow {
  display: flex;
  flex-direction: row;
}
.marginRightXm {
  margin-right: 5px;
}
.marginTopXs {
  margin-top: 20px;
}
.marginTopXm {
  margin-top: 10px;
}
.marginBottomXs {
  margin-bottom: 20px;
}
.marginBottomXm {
  margin-bottom: 10px;
}
.textCenter {
  text-align: center;
}
.cardTitle {
  font-size: 16px;
  color: rgb(87, 76, 70);
  font-weight: 600;
}
.cardTitleSub {
  font-size: 12px;
  color: rgb(153, 153, 153);
}
.paddingXm {
  padding: 10px;
}
.paddingXs {
  padding: 20px;
}
.fixBottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100%;
}

@keyframes show {
  0% {
    transform: translateY(-50px);
  }

  60% {
    transform: translateY(40upx);
  }

  100% {
    transform: translateY(0px);
  }
}

@-webkit-keyframes show {
  0% {
    transform: translateY(-50px);
  }

  60% {
    transform: translateY(40upx);
  }

  100% {
    transform: translateY(0px);
  }
}
html {
  overflow-y: scroll;
}
:root {
  overflow-x: auto;
  /* overflow-y: hidden; */
}
:root body {
  position: absolute;
}
body {
  width: 100vw;
  overflow: hidden;
}
</style>
